export default __webpack_public_path__ + "static/media/fi-sr-quote-left.e2ca3438.svg";